import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { ApiEndpoint } from "../@core/endpoint";
import { EntityType } from "../@core/entityType";
import { fetchData, postData, updateData } from "../../helpers/utils";
import { CREATE_LICENSE, GET_ALL_LICENSES_BY_CLIENT, UPDATE_ARBIS_AI_LICENSE } from "./actionTypes";
import { createLicenseActions, getAllLicensesByClientActions, updateArbisAiLicenseActions } from "./actions";
import { API_URL } from "../../config";
import {ActionStates, buildAsyncActionType} from "reactcoregk/store/actions";

const entityType = EntityType.License

function* getLicensesByClient({ payload  }) {
  try {
    const url = `${API_URL}/api/clients/${payload}/licenses`;
    const result = yield call(fetchData, url);
    yield put(getAllLicensesByClientActions.success(result));
  } catch (error) {
    yield put(getAllLicensesByClientActions.failure(error.message));
  }
}

function* createLicense({ payload }) {
  try {
    const { arbisAiEnabled, arbisAiStartsAt, arbisAiExpiresAt, ...licensePayload } = payload;
    const url = ApiEndpoint[entityType];
    const result = yield call(postData, url, licensePayload);
    if (arbisAiEnabled && result?.id) {
      const arbisUrl = `${API_URL}/api/evolvable/license`;
      yield call(postData, arbisUrl, {
        clientId: parseInt(payload.clientId),
        uni5LicenseId: result.id,
        startsAt: arbisAiStartsAt,
        expiresAt: arbisAiExpiresAt,
      });
    }
    yield put(createLicenseActions.success(result));
    yield put(getAllLicensesByClientActions.request(payload.clientId));
  } catch (error) {
    yield put(createLicenseActions.failure(error.message));
  }
}

function* updateArbisAiLicense({ payload }) {
  try {
    const { licenseId, clientId, arbisAiEnabled } = payload;
    if (!arbisAiEnabled) {
      const url = `${API_URL}/api/evolvable/license/${licenseId}/remove`;
      yield call(updateData, url, {});
    }
    yield put(updateArbisAiLicenseActions.success({}));
    yield put(getAllLicensesByClientActions.request(clientId));
  } catch (error) {
    yield put(updateArbisAiLicenseActions.failure(error.message));
  }
}

export function* watchLicenseByClientFetch() {
  const actionType = buildAsyncActionType(entityType, GET_ALL_LICENSES_BY_CLIENT, ActionStates.request)
  yield takeEvery(actionType, getLicensesByClient);
}

export function* watchLicenseCreation() {
  const actionType = buildAsyncActionType(entityType, CREATE_LICENSE, ActionStates.request)
  yield takeEvery(actionType, createLicense);
}

export function* watchArbisAiLicenseUpdate() {
  const actionType = buildAsyncActionType(entityType, UPDATE_ARBIS_AI_LICENSE, ActionStates.request)
  yield takeEvery(actionType, updateArbisAiLicense);
}

function* sagas() {
  yield all([fork(watchLicenseByClientFetch), fork(watchLicenseCreation), fork(watchArbisAiLicenseUpdate)]);
}

export default sagas;
